exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-times-documentoscopia-component .empty-title{font-size:26px;text-align:center;font-weight:normal}.table-times-documentoscopia-component .type-call{font-family:\"PT Mono\";font-style:normal;font-weight:normal;font-size:14px;line-height:18px;margin-top:20px;padding:2px 4px;border-radius:5px}.table-times-documentoscopia-component .type-call.error{border:1px solid #ea2151;color:#ea2151}.table-times-documentoscopia-component .type-call.warning{color:#ffb240;border:1px solid #ffb240}.table-times-documentoscopia-component .type-call.success{border:1px solid #6fcf97;color:#6fcf97}", ""]);

// exports
